import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { OfficeStore } from '@pages/office/store/office.store';
import { IOfficeField } from '../../../../models/office-data.model';
import { LookupModalComponent } from '../../../../../../modals/office/lookup-modal/lookup-modal.component';
import { OfficeFormHelperService } from '../../office-form-helper.service';
import { FormControlConfig } from '@pages/office/office-form/office-form/form-controls/models/form-control-config.model';

@Component({
  selector: 'app-lookup-button',
  templateUrl: 'lookup-button.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LookupButtonComponent {
  @Input({ required: true }) officeField: IOfficeField;
  @Input({ required: true }) formGroupInstance: FormGroup;
  @Input() disabled: boolean;
  @Input() config: FormControlConfig;

  private modalService = inject(NgbModal);
  private officeStore = inject(OfficeStore);
  private formService = inject(OfficeFormHelperService);

  public openLookupModal({ Seq, AvailableLookups }: IOfficeField): void {
    const postData = !this.config?.doNotSendDataForLookup
      ? this.formService.getStringFormValue(this.formService.getOfficeToolsRawValue())
      : null;
    const modalRef = this.modalService.open(LookupModalComponent, {
      size: 'xl',
    });
    const defaultLookup = this.officeField.DefaultLookup;
    let availableLookups = AvailableLookups;

    if (availableLookups.some(availableLookup => availableLookup.Active)) {
      availableLookups = availableLookups.filter(availableLookup => availableLookup.Active);
    } else if (defaultLookup) {
      availableLookups = availableLookups.filter(availableLookup => availableLookup.Lookup === defaultLookup);
    }
    const lookup = Array.isArray(availableLookups) && availableLookups.length > 0 ? availableLookups[0].Lookup : null;

    modalRef.componentInstance.lookupParams = {
      co: this.officeStore.selectedCompany$(),
      form: this.officeStore.selectedForm$(),
      seq: Seq,
      lookup: lookup,
      formData: postData,
      showAllColumns: true,
      searchString: '',
    };
    modalRef.componentInstance.availableLookups = availableLookups;
    modalRef.componentInstance.modalTitle = availableLookups[0]?.Title;
    modalRef.componentInstance.webInputType = this.officeField.WebInputType;
    modalRef.componentInstance.mask = this.officeField.InputMask;

    modalRef.result
      .then((result: object) => {
        if (!result) return;
        const control = this.formGroupInstance.get([Seq]);
        control.markAsDirty();
        control.setValue(result[Object.keys(result)[0]]);
      })
      .catch(() => {});
  }
}
